export enum DecisionDatesPopoverId {
  editDecisionDatePopover = 'editDecisionDatePopover',
  editIssuedOnPopover = 'editIssuedOnPopover',
  editValidFromPopover = 'editValidFromPopover'
}
